'use strict';

const $ = require('jquery');

var $scrollToTopLinks = $('.js-to-top');

$scrollToTopLinks.click(function() {
    $('html, body').animate({
        scrollTop: 0,
    }, 1500);

    return false;
});
